<script setup lang="ts">
import type { MagazineSuggestionsGroupsProps } from "./MagazineSuggestionsGroups.props"
import type { ButtonProps } from "~/components/Utils/Button.props"

const props = defineProps<MagazineSuggestionsGroupsProps>()

const { t } = useI18n()

const emit =
  defineEmits<{
    (e: "clickSuggestions", item: ButtonProps): void
  }>()
</script>

<template>
  <!-- No results message -->
  <div
    v-if="queryState.length > 2 && (!suggestions || suggestions.length === 0)"
    class="search-suggestions"
  >
    <p class="dolphin-bold md:hippo-bold text-black-60 px-4 pb-4 md:px-0">
      {{ t("magazine.search.noResults", { query: queryState.toLowerCase() }) }}
    </p>
  </div>
  <SearchUtilsSuggestions
    v-if="
      lastSearch?.length &&
      (queryState.length <= 2 || !suggestions || suggestions?.length === 0)
    "
    class="col-span-1 pb-4 md:pb-0"
    :title="t('magazine.search.labelLastSearchs')"
    :suggestions="lastSearch"
    :paddingTop="false"
    @click="emit('clickSuggestions', $event)"
  />
  <SearchUtilsSuggestions
    v-if="
      lastViewed?.length &&
      (queryState.length <= 2 || !suggestions || suggestions?.length === 0)
    "
    class="col-span-1 pb-4 md:pb-0"
    :title="t('magazine.search.labelLastViewed')"
    :suggestions="lastViewed"
    :paddingTop="Boolean(lastSearch?.length)"
    @click="emit('clickSuggestions', $event)"
  />
  <!-- Popular searches -->
  <SearchUtilsSuggestions
    v-if="
      querySuggestions?.length &&
      (!lastSearch?.length || !lastViewed?.length) &&
      (queryState.length <= 2 || !suggestions || suggestions?.length === 0)
    "
    class="col-span-1 pb-4 md:pb-0"
    :title="t('magazine.search.popularSearch')"
    :suggestions="querySuggestions"
    :paddingTop="Boolean(lastSearch?.length || lastViewed?.length)"
    @click="emit('clickSuggestions', $event)"
  />
  <SearchUtilsSuggestions
    v-if="suggestions?.length"
    :title="t('magazine.search.suggestions')"
    :suggestions="suggestions"
    class="col-span-1 pb-4 md:pb-0"
    @click="emit('clickSuggestions', $event)"
    :paddingTop="false"
  />
  <SearchUtilsSuggestions
    v-if="categorySuggestions?.length"
    :title="t('magazine.search.categorySuggestions')"
    :suggestions="categorySuggestions"
    class="col-span-1 pb-4 md:pb-0"
    :paddingTop="Boolean(suggestions?.length)"
    @click="emit('clickSuggestions', $event)"
  />
</template>
